import { render, staticRenderFns } from "./SupplierContact.vue?vue&type=template&id=2105f775&"
import script from "./SupplierContact.vue?vue&type=script&lang=js&"
export * from "./SupplierContact.vue?vue&type=script&lang=js&"
import style0 from "./SupplierContact.vue?vue&type=style&index=0&id=2105f775&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports